import {
  ThemeDarkValues,
  ThemeLightValues,
} from '@picsart/design-system/foundation/colors';
import { useFoundation } from '@picsart/design-system/foundation/initFoundation';

// Always use dark theme
const themes = [
  {
    key: 'light',
    value: ThemeLightValues,
    selected: false,
  },
  {
    key: 'dark',
    value: ThemeDarkValues,
    selected: true, // Always dark
  },
];

const useThemeChange = () => {
  // Initialize Design System CSS variables with dark theme always selected
  useFoundation({ themes });
};

export default useThemeChange;
